import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';


function Counter({ target, duration = 2000 }) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const increment = target / (duration / 50);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, 50);

    return () => clearInterval(timer);
  }, [target, duration]);

  return <>{count}</>;
}

function HappyClients() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 50,
      easing: 'ease-in-out',
      once: false
    });
  }, []);

  return (
    <div className="status">
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div className="col-lg-3 col-md-6 col-sm-12 box mb-3 mb-lg-0" data-aos="fade-right">
              <div className="status-block">
                <img src="/assets/images/records/building.svg" alt="Company Founded" />
                <span className="number"><Counter target={2012} duration={2000} /></span>
                <h4>Company Founded</h4>
              </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 box mb-3 mb-lg-0" data-aos="fade-right">
              <div className="status-block">
                <img src="/assets/images/records/complete-projects.svg" alt="Projects Delivered" />
                <span className="number"><Counter target={100} duration={2000} />+</span>
                <h4>Projects Delivered</h4>
                </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 box mb-3 mb-lg-0" data-aos="fade-right">
              <div className="status-block">
                  <img src="/assets/images/records/employees.svg" alt="Employee Base" />
                  <span className="number"><Counter target={60} duration={2000} />+</span>
                  <h4>Employee Base</h4>
              </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 box mb-3 mb-lg-0" data-aos="fade-left">
              <div className="status-block">
                <img src="/assets/images/records/happy-clients.svg" alt="Repeat Clients" />
                <span className="number">94%</span>
                <h4>Satisfied Clients</h4>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HappyClients;
